// extracted by mini-css-extract-plugin
module.exports = {"tcyd78g":"tcyd78g"};